/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Location} from "../models/location";
import {LocationService} from "../services/location.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class LocationsResolver implements Resolve<Location[]> {

  constructor(
    private mLocationService: LocationService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Location[]> {
    try {
      return await this.mLocationService.getAllLocations();
    } catch (error) {
      console.error("Problem resolving Locations... Error: " + error, error);
    }
  }

}
